import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useViewerSession } from '../useViewerSession';

/**
 * Auth guard wrapper — redirects unauthenticated users to login.
 *
 * Usage:
 *   <RequireAuth><ProtectedPage /></RequireAuth>
 *
 * Or via the route config:
 *   { path: '/onboard', element: Onboard, requiresAuth: true }
 */
export default function RequireAuth({
  children
}: {
  children: React.ReactNode;
}) {
  const { storedUser } = useViewerSession();
  const location = useLocation();

  if (!storedUser) {
    // Save the attempted URL so we can redirect back after login
    return (
      <Navigate
        to="/identity/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
}
